<template>
    <div class="Workflowcard Popover no-smoothscroll" :class="{ 'active': workflowcardPopoverData.open }">
        <div class="inner cs_form">
            <div class="top">
                <div class="Heading">
                    <span class="left">
                        <h3 class="h3">{{ workflowcardPopoverTitle }}</h3>
                    </span>
                    <div class="right">
                        <button type="button" class="more-icon" @click.prevent="closeWorkflowcardPopover">
                            <Icon name="close" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="middle">
                <div class="middle-inner no-smoothscroll">
                    <template v-if="workflowcardPopoverType === 'details'">
                        <detail-overview
                            module_object="Workflowcard"
                            :key="`details_${workflowcardPopoverId}`"
                            :item_id="workflowcardPopoverId"
                            teleport_navbar=".Workflowcard.Popover .bottom nav"
                        />
                    </template>
                    <template v-else-if="workflowcardPopoverType === 'comments'">
                        <message-overview
                            module_object="Workflowcard"
                            :key="`comments_${workflowcardPopoverId}`"
                            :item_id="workflowcardPopoverId"
                            teleport_remarkbar=".Workflowcard.Popover .bottom"
                        />
                    </template>
                    <template v-else-if="workflowcardPopoverType === 'attachments'">
                        <file-overview
                            module_object="Workflowcard"
                            :key="`attachments_${workflowcardPopoverId}`"
                            :item_id="workflowcardPopoverId"
                            :hide_delete="true"
                        />
                    </template>
<!--                    <template v-else-if="workflowcardPopoverType === 'inbox'">-->
<!--                        <inbox-overview-->
<!--                            module_object="Workflowcard"-->
<!--                            :key="`inbox_${workflowcardPopoverId}`"-->
<!--                            :item_id="workflowcardPopoverId"-->
<!--                        />-->
<!--                    </template>-->
                </div>
            </div>
            <div class="bottom">
                <nav><Actions
                    :classlist="{ inner: true }"
                    v-if="isButtonsVisible && (isCompanyUndefinedAllowed || company) && workflowcardPopoverId && (workflowcardPopoverType === 'details')" :key="workflowcardPopoverData.workflowphase_id"
                    :item="resolveItem(workflowcardPopoverData.item)"
                    :workflowcard_id="workflowcardPopoverId"
                    :workflowboard_id="workflowcardPopoverData.workflowboard_id"
                    :workflowphase_id="workflowcardPopoverData.workflowphase_id"
                /></nav>
            </div>
        </div>
        <div class="bg" @click.prevent="closeWorkflowcardPopover"></div>
    </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, inject, watch, computed, provide} from "vue";
import {useRoute, useRouter} from "vue-router";

// Helper functions
import trans from "helpers/_translation";

// Our components
import State from "components/workflowcard/state";
import Cardlink from "components/workflowcard/cardlink";
import Icon from "components/icon";
import cardTitle from "components/workflowcard/cardtitle";

import MessageOverview from "components/message-overview";
// import InboxOverview from "components/inbox-overview";
import FileOverview from "components/file-overview";

import Actions from "components/workflowcard/actions";

import { isCompanyUndefinedAllowed } from "store/portal";
import { company } from "store/company";

import {
    workflowcardPopoverData,
    workflowcardPopoverTitle,
    workflowcardPopoverId,
    workflowcardPopoverType,
    closeWorkflowcardPopover
} from "store/workflowcard-popover";

export default defineComponent({
    name: "workflowcard-popover",
    computed: {
        workflowcardPopoverTitle() {
            return workflowcardPopoverTitle
        }
    },
    components: {
        Actions,

        State,
        Cardlink,
        cardTitle,
        Icon,

        MessageOverview,
        // InboxOverview,
        FileOverview
    },
    props: {},
    setup() {
        const router = useRouter();

        // Our general data, used for resolving the title
        const viewData = inject("viewData");
        const generalData = inject("generalData");
        const boardSettings = inject("boardSettings");

        const isButtonsVisible = inject("isButtonsVisible");

        const resolveItem = (data) => {
            return computed(() => {
                return {
                    data: data
                }
            }).value;
        };


        return {
            trans,
            generalData,
            boardSettings,

            workflowcardPopoverData,
            workflowcardPopoverTitle,
            workflowcardPopoverId,
            workflowcardPopoverType,

            closeWorkflowcardPopover,

            isButtonsVisible,

            viewData,
            company,
            isCompanyUndefinedAllowed,

            resolveItem
        };
    },
});
</script>

<style lang="scss">
@import "mixins";
@import "variables";
#app {
    .Workflowcard.Popover {
        pointer-events: none;
        visibility: hidden;

        > .inner {
            left: 100%;
            top: 0;
            bottom: 0;
            transform: translate(0, 0);
            display: block;
            background: #fff;
            padding: 30/16*1rem;
            transition: all .3s ease-in-out;
            transition-delay: .2s;
            @include media("min",768,0) {
                width: 500/16*1rem;
            }
            @include media("max", 767, 0) {
                width: 500px;
                max-width: calc(100vw - 30px);
            }
        }

        .Heading {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;
        }


        > .bg {
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(#000, 0.5);
            cursor: pointer;
            transition: all .3s ease-in-out;
        }

        > .inner, > .bg {
            position: fixed;
            z-index: -1;
            display: block;
            opacity: 0;
        }

        &.active {
            pointer-events: all;
            visibility: visible;

            > .inner {
                z-index: 10006;
                opacity: 1;
                transform: translate(-100%, 0);
            }

            > .bg {
                z-index: 5100;
                opacity: 1;
                transition: none;
            }
        }

        > .inner {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            gap: 20/16*1rem;

            height: var(--100vh, 100vh);

            > * {
                position: relative;
            }

            > .top {
                padding-bottom: 20/16*1rem;
                border-bottom: 1px solid $border;
            }

            > .middle {
                height: 100%;
                overflow: hidden;

                > .middle-inner {
                    overflow-x: hidden;
                    overflow-y: auto;
                    max-height: 100%;
                    height: 100%;
                }
            }

            > .bottom {
                &:empty {
                    display: none;
                }
                nav {
                    justify-content:flex-end;
                    flex-wrap:wrap;
                    align-items:stretch;
                    .more {
                        flex:1;
                        min-width:90px;
                    }
                    > .inner {
                        display: flex; flex-direction: row; justify-content: flex-start; align-items:stretch;
                        flex:1; min-width:100%;

                        @include media("min",768,0) {

                            &:first-child {
                                border-top: 1px solid $border;
                                padding-top:20px; margin-top:-20px;
                            }
                            &:last-of-type {
                                border-bottom: 1px solid $border;
                                margin-bottom: 10px;
                                padding-bottom: 20px;
                            }
                        }
                        @include media("max",767,0) {
                            &:first-child {
                                border-top: 1px solid $border;
                                padding-top:10px; margin-top:-10px;
                            }
                            &:last-of-type {
                                border-bottom: 1px solid $border;
                                margin-bottom: 5px;
                                padding-bottom: 10px;
                            }
                        }
                    }
                }
                .RemarkBar {
                    margin-bottom:0;
                }
            }
        }

        .cs_form {
            .tab {
                .fieldset {
                    overflow: hidden;
                }

                font-size: 14px;

                .element > label {
                    font-weight: 600;
                    font-size: 12px;
                    color: $textcolor2;
                    padding-bottom:7px;
                }

                .input {
                    border: 0;
                    background: none transparent;
                    padding: 0;
                }

                .TextareaField .Content, .EditorField .Content {
                    padding: 0;
                    border: 0;
                    line-height: inherit;
                }

                var {
                    font-style: normal;
                }

                .input-group {
                    border:0; background:none transparent;
                    gap:5px;
                }
                .Content {
                    font-size:1em;
                }

                .CardField .tags .tag {
                    cursor: pointer;
                    justify-content: space-between;
                    width: 100%;

                    .toggle {
                        text-decoration: underline;
                    }

                    &:hover .toggle {
                        text-decoration: none;
                    }
                }

                .tab-details {
                    border: 1px solid $border;
                    border-radius: $radius;
                    padding: 0 15px 15px 15px;
                    margin-top: 10px;
                }
            }
        }


        .RemarkBar > .element.MessageField {
            flex-wrap: wrap;
            justify-content:flex-end;
            textarea {
                width:100%; flex:unset;
            }
        }

        &.hasscroll {
            > .inner {
                > .top > .Element:not(.boxed):last-child::after,
                > .bottom > .Element:not(.boxed):first-child::before {
                    content: none;
                }

                > .top {
                    box-shadow: 0 0 20/16*1rem rgba(#000, 0.45);
                }

                > .bottom {
                    box-shadow: 0 0 20/16*1rem rgba(#000, 0.45);
                }
            }
        }
    }
}
</style>